import React from 'react';
import { Box, Typography, Paper, CircularProgress } from '@mui/material';
import MarkdownRenderer from '../common/MarkdownRenderer';

const ConversationPanel = ({ messages, isLoading, readOnly = false }) => {
  return (
    <Box sx={{ flex: 1, overflow: 'auto', p: 2 }}>
      {messages.length === 0 && !isLoading && (
        <Paper sx={{ p: 3, textAlign: 'center' }}>
          <Typography variant="body1" color="text.secondary">
            No conversation history available
          </Typography>
        </Paper>
      )}
      
      {messages.map((message, index) => (
        <Box
          key={index}
          sx={{
            mb: 2,
            display: 'flex',
            justifyContent: message.role === 'user' ? 'flex-end' : 'flex-start'
          }}
        >
          <Paper
            sx={{
              p: 2,
              maxWidth: '80%',
              backgroundColor: message.role === 'user' ? 'primary.light' : 'grey.100',
              color: message.role === 'user' ? 'primary.contrastText' : 'text.primary'
            }}
          >
            <Typography variant="caption" sx={{ fontWeight: 'bold', mb: 1, display: 'block' }}>
              {message.role === 'user' ? (message.createdByName || message.created_by_name || 'You') : 'AI Assistant'}
            </Typography>
            <MarkdownRenderer content={message.content} />
          </Paper>
        </Box>
      ))}
      
      {isLoading && (
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
          <CircularProgress size={24} />
        </Box>
      )}
    </Box>
  );
};

export default ConversationPanel;